module.exports = __webpack_public_path__ + "img/colossus.ae4afba1.webp";